<template>
  <div class="confirmation">
    <template v-if="!failed">
      <h3><strong>Idylive vous remercie pour votre confiance. </strong></h3>
      <p v-if="sere">
        Votre
        <strong>
          Pass <span class="sere">Sérénité</span> a bien été activé !<br /><br />
          Vous bénéficiez désormais de tous les avantages du Pass <span class="sere">Sérénité</span>.
        </strong>
      </p>
      <p v-else>
        Votre <strong>Pass</strong> <ColoredName /> est désormais actif ! Vous pouvez lire et répondre à tous vos
        messages !
      </p>
      <a href="/v3/accueil" class="bouton">Continuer sur Idylive</a>
    </template>
    <template v-else>
      <h3>Echec du paiement</h3>
      <p class="echec">Votre paiement n'a pas été accepté... ☹️</p>
      <p>
        Si ce problème ce reproduit, n'hésitez pas à contacter Idylive en cliquant sur le lien présent en haut à droite
        de l'écran, ou en écrivant un email à <strong>contact@idylive.fr</strong>
      </p>
      <p>
        Il est possible de régler par chèque ou par virement bancaire, vous pouvez cliquer sur Essayer à nouveau pour
        utiliser un autre moyen de paiement.
      </p>
      <div class="boutons">
        <router-link v-if="sales" :to="{ name: 'payment', query: { id: sales.product.id } }" class="bouton"
          >Essayer à nouveau</router-link
        >
        <a href="/v3/accueil" class="bouton">Retourner sur Idylive</a>
      </div>
    </template>
  </div>
</template>

<script>
import ColoredName from "@/components/util/ColoredName";
import { idyuJsonRpc } from "../../assets/js/idyu/connect";

export default {
  data() {
    return {
      sales: null
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init();
    });
  },

  methods: {
    async init() {
      if (this.$route.query.payment_intent) {
        try {
          this.sales = await idyuJsonRpc("getSalesFromIntentId", this.$route.query.payment_intent);
        } catch {
          this.sales = null;
        }

        if (this.sales && this.$gtag) {
          this.$gtag.event("conversion", {
            send_to: "AW-1050781183/d-jJCOmS_VYQ_8uG9QM",
            value: this.sales.price,
            currency: "EUR",
            transaction_id: this.$route.query.payment_intent
          });
        }
      }
    }
  },
  components: { ColoredName },
  computed: {
    sere() {
      return this.$router.currentRoute.hash.includes("sere");
    },

    failed() {
      return this.$route.query.redirect_status === "failed";
    }
  }
};
</script>

<style scoped lang="scss">
.confirmation {
  padding-top: 10px;
}
.sere {
  color: green;
}

.echec {
  margin-bottom: 10px;
  font-size: 18px;
}
.boutons {
  display: grid;
  grid-gap: 10px;
}
</style>
